import React from 'react';
import { Box, Typography, Paper, Grid } from '@mui/material';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SmartToyIcon from '@mui/icons-material/SmartToy';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import TuneIcon from '@mui/icons-material/Tune';

export const BannerInfoAjustesGlobalesIa = () => {
    return (
        <Paper 
            elevation={0}
            sx={{ 
                mt: 3, 
                p: { xs: 3, md: 4 }, 
                backgroundColor: '#F8F7FA',
                borderRadius: 3,
                border: '1px solid #EAEAFF',
                mb: 3
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 3 }}>
                <Box sx={{ p: 1, borderRadius: '50%', backgroundColor: '#E8E7FD', display: 'flex', mr: 2 }}>
                    <SettingsSuggestIcon sx={{ color: '#696CFF', fontSize: 32 }} />
                </Box>
                <Box>
                    <Typography variant="h6" sx={{ color: '#696CFF', fontWeight: 700, mb: 0.5, fontSize: '1.15rem' }}>
                        ¿Qué son los Ajustes Globales de IA?
                    </Typography>
                    <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 500, maxWidth: '80%' }}>
                        Administra y centraliza la configuración base para todos los servicios de Inteligencia Artificial que se utilizan en la plataforma.
                    </Typography>
                </Box>
            </Box>

            <Grid container spacing={3} sx={{ pl: { xs: 0, sm: 8.5 } }}>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <SmartToyIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Servicios por Defecto</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Configura qué servicios de IA se usarán por defecto para las distintas funcionalidades del sistema.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <MonetizationOnIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Consumo y Créditos</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Establece los límites de consumo, la conversión de valor de token y la asignación de créditos base.
                        </Typography>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 4}}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <TuneIcon sx={{ color: '#696CFF', fontSize: 28 }} />
                        <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>Opciones Globales</Typography>
                        <Typography variant="body2" color="text.secondary">
                            Define opciones avanzadas globales que aplicarán a todos los tenants a menos que se sobreescriban.
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    );
};
